import { DOCUMENTOS, INUTILIZACOES } from "./documentos";

const REGISTROS = [...DOCUMENTOS, ...INUTILIZACOES];

export function verificarNumero(linha) {
	const inutilizado = linha.status === "INUTILIZADA";

	return {
		tentativa: false,
		documento: false,
		xml: inutilizado,
		protocolo: inutilizado,
		inutilizado,
		precisaInutilizar: !inutilizado,
		venda: false,
	};
}

export function vizinhosDe(linha) {
	const mesmaSerie = REGISTROS.filter((r) => r.modelo === linha.modelo && r.serie === linha.serie).sort(
		(a, b) => a.numero - b.numero
	);

	return {
		anterior: mesmaSerie.filter((r) => r.numero < linha.numero).pop(),
		seguinte: mesmaSerie.find((r) => r.numero > linha.numero),
	};
}
